import { ResetPasswordPayload } from '../models/reset-password.model';

export class Login {
  readonly type = '[Auth] Login';
}

export class LoginFailed {
  readonly type = '[Auth] LoginFailed';
}

export class LoginSuccess {
  readonly type = '[Auth] LoginSuccess';
  constructor(public payload: string) {}
}

export class LoadFail {
  readonly type = '[Auth] LoadFail';
  constructor(public payload: any) {}
}

export class SendEmail {
  readonly type = '[Auth] SendEmail';
}

export class SendEmailSuccess {
  readonly type = '[Auth] SendEmailSuccess';
}

export class SendEmailFailed {
  readonly type = '[Auth] SendEmailFailed';
}

export class ResetPassword {
  readonly type = '[Auth] ResetPassword';
  constructor(public payload: ResetPasswordPayload) {}
}

export class ResetPasswordSuccess {
  readonly type = '[Auth] ResetPasswordSuccess';
}

export class ResetPasswordFailed {
  readonly type = '[Auth] ResetPasswordFailed';
}

export class ResetLoginForm {
  readonly type = '[Auth] ResetLoginForm';
}

export class ValidateResetLink {
  readonly type = '[Auth] ValidateResetLink';
  constructor(public payload: ResetPasswordPayload) {}
}

export class SetToken {
  readonly type = '[Auth] SetToken';
  constructor(public token: string) {}
}
